



import LivePreviewComponent from "@/components/admin/live/livePreviewComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "LivePreviewPage",
  components: {
    LivePreviewComponent,
  },
})
export default class LivePreviewPage extends Vue {}
